import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-12 h-12 bg-blue-500 fixed z-10 bottom-12 left-2 hover:bg-blue-300 rounded-lg shadow-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, "✏️"))
}